import axios from 'axios';
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

/* Session length. It SLIDES on activity — every authenticated navigation runs
   checkAutoLogin, which pushes the expiry forward — so an actively-used session
   is never logged out mid-navigation. Only genuine inactivity for this long
   logs the user out. (Was a hard 1h/2.5h cap with accumulating, never-cleared
   timers, which logged users out during normal use — Pavithra #5.) */
export const SESSION_TTL_MS = 8 * 60 * 60 * 1000; // 8 hours

/* one logout timer, cleared + reset each time so timers never stack up */
let logoutTimerId = null;

export async function signUp(email, password, firstName, lastName, username, country,phone_number) {
    const formData = {
        action: 'sign-up',
        first_name: email,
        last_name: password,
        username: lastName,
        email: username,
        password: country,
        country: firstName,
        phone_number:phone_number,
        app_name: "careersavvy"
    };

    try {
        const response = await fetch('https://us-east1-foursssolutions.cloudfunctions.net/user_authentication_api_v2', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        return response; // Return the fetch response
    } catch (error) {
        console.error('Error in sign-up:', error.message);
        throw error;
    }
}
export function loginToAPI(loginEmail, loginPassword) {
    // Create the request payload
    const formData = {
        action: 'sign-in',
        username: loginEmail,
        password: loginPassword,
        app_name: "careersavvy"
    };

    console.log('Login formData:', formData);  // Log the request payload for debugging

    return axios.post(
        'https://us-east1-foursssolutions.cloudfunctions.net/user_authentication_api_v2',
        formData,
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
    .catch(error => {
        console.error('Error in loginToAPI:', error.response ? error.response.data : error.message);
        throw error;  // Re-throw error to be caught by the calling function
    });
}

export function login(email, password) {
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function formatError(error) {
    let message = "An error occurred";  // Default error message
    
    if (error && error.message) {
        message = error.message;
    }
    
    return message;
}



export function saveTokenInLocalStorage(tokenDetails) {
    const tokenData = {
        token: tokenDetails.token,
        email: tokenDetails.email,
        storagePath: tokenDetails.storage_path,
        globalSessionId: tokenDetails.global_session_id,
        accessToken: tokenDetails.access_token,
        subscription: tokenDetails.subscription_type,
        expireDate: new Date(new Date().getTime() + SESSION_TTL_MS),
    };
    localStorage.setItem('userDetails', JSON.stringify(tokenData));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    if (logoutTimerId) clearTimeout(logoutTimerId);
    logoutTimerId = setTimeout(() => {
        dispatch(Logout(navigate));
    }, timer);
}

// AuthService.js
/* Pages that must render for signed-OUT visitors — never bounce these to /login.
   Everything NOT listed is treated as an authenticated app route. The footer /
   legal / SEO paths were missing here, which sent every public page to /login. */
const PUBLIC_PATHS = new Set([
    '/', '/robots.txt', '/sitemap.xml',
    '/blog', '/blogDetailed',
    '/ai-resume-builder', '/resume-tailoring', '/ai-job-search',
    '/mock-interview-practice', '/interview-preparation',
    '/privacy', '/terms', '/cookies', '/gdpr', '/contact',
    '/job/detailed',
    '/resetpassword', '/reactivate-link', '/page-forgot-password', '/page-register',
    '/interview', '/interview-Candidate-exam', '/interview-Video-exam',
    /* NOTE: /interview-exam and /videoInterview are AUTHED exam runners — they are
       intentionally NOT public, so a signed-out visitor is sent to /login. The
       three above are the legacy candidate-facing (public) interview surfaces. */
]);

export function checkAutoLogin(dispatch, navigate, locationPath) {
    const tokenDetailsString = localStorage.getItem('userDetails');

    /* a logged-in user landing on /login goes straight to their dashboard */
    if (tokenDetailsString && locationPath === '/login') {
        navigate('/dashboard');
        return;
    }

    /* Returning from the Stripe checkout while still logged in (success -> /activate,
       cancel/back -> /cancel): KEEP the session and send them to Subscription,
       which re-reads plan status from the DB. Previously this removed the token +
       hard-refreshed, which bounced logged-in users to /login on cancel/back — the
       reported "upgrade -> back -> login" redirect bug. (Email activation still
       works: a logged-OUT user has no token, so this branch is skipped and the
       public /activate page renders below.) */
    if (tokenDetailsString && (locationPath === '/activate' || locationPath === '/cancel')) {
        navigate('/subscription');
        return;
    }

    /* public marketing / legal / auth pages render without a login */
    if (!tokenDetailsString && (PUBLIC_PATHS.has(locationPath) || locationPath === '/activate')) {
        return;
    }

    /* no token on a protected app route -> log out (routes them to /login) */
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    /* token present: honour expiry, else confirm the session + set the timer */
    const tokenDetails = JSON.parse(tokenDetailsString);
    const expireDate = new Date(tokenDetails.expireDate);
    const todaysDate = new Date();
    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
    dispatch(loginConfirmedAction(tokenDetails));
    /* sliding session: push the expiry forward on each authenticated navigation
       so an active user is never logged out mid-session (Pavithra #5). */
    tokenDetails.expireDate = new Date(todaysDate.getTime() + SESSION_TTL_MS);
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
    runLogoutTimer(dispatch, SESSION_TTL_MS, navigate);
}

export function isLogin() {
    const tokenDetailsString = localStorage.getItem('userDetails');

    if (tokenDetailsString) {
        return true;
    }else{
        return false;
    }
}